// @flow

export const MAP_FIELDS_NAME = {
  name: 'Nombre de producto',
  price: 'Precio de producto',
  videoUrl: 'Url de producto',
  sku: 'SKU',
  stock: 'Stock',
  'variant-': 'Variantes',
  'sub-cate': 'Subcategorías',
};

export const PRODUCT_TABS = [
  {
    name: 'General',
    key: 'general',
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  {
    name: 'Variantes',
    key: 'variants',
    storeBusinessModels: ['PRODUCT'],
  },
  {
    name: 'Secciones',
    key: 'sections',
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  {
    name: 'Opciones',
    key: 'options',
    storeBusinessModels: ['PRODUCT'],
    storeFeatures: ['PRODUCT_OPTIONS'],
  },
  {
    name: 'Precios al por mayor',
    key: 'bulkprice',
    storeBusinessModels: ['PRODUCT'],
  },
  {
    name: 'Elementos Relacionados',
    key: 'relatedProducts',
    storeBusinessModels: ['PRODUCT', 'SERVICE'],
  },
  {name: 'SEO', key: 'seo', storeBusinessModels: ['PRODUCT', 'SERVICE']},
];

export const FIELDS_BY_TAB_NAME = {
  general: [
    {field: 'name'},
    {field: 'missingImage'},
    {field: 'price'},
    {field: 'taxedPrice'},
    {field: 'offerPrice'},
    {field: 'taxedOfferPrice'},

    {field: 'productFeatures', withoutExactMatch: true},
    {field: 'stock'},
    {field: 'sku'},
  ],
  variants: [{field: 'variant-stock-', withoutExactMatch: true}],
  sections: [
    {
      field: 'productSections',
      withoutExactMatch: true,
    },
  ],
  bulkprice: [
    {field: 'bulkPriceLine'},
    // {field: 'unitPrice-', withoutExactMatch: true},
    // {field: 'taxedUnitPrice-', withoutExactMatch: true},
  ],
  relatedProducts: [{field: 'enabledRelatedProducts'}],
  seo: [
    {field: 'metaTitle'},
    {
      field: 'metaDescription',
    },
  ],
};

export const BLACKLIST_STORES_FOR_PRODUCT_SEARCH = [];
